import { requestQueue } from './requestQueue'
import { getApiUrl } from './apiBaseUrl'

async function postData(url = '', data = {}, signal) {
  const seed = Math.random()
  requestQueue.push(seed)
  const fullUrl = getApiUrl(url)
  try {
    const response = await fetch(fullUrl, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(data),
      signal
    })

    const responseJson = await response.json()
    requestQueue.pop(seed)

    if (responseJson.redirect) {
      window.location.href = window.location.origin + responseJson.redirect
      return {}
    }
    return responseJson
  } catch (e) {
    console.error(e)
    requestQueue.pop(seed)
    return {}
  }

}

export default postData
